import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="name-duplicate-hint"
export default class extends Controller {
  static targets = ["firstName", "lastName", "middleName", "suffixName", "birthDate", "warning"]
  static values = {
    memberId: Number,
    checkUrl: String 
  }

  connect() {
    this.debounceTimer = null
    this.activeRequest = null 
  }

  disconnect() {
    clearTimeout(this.debounceTimer)
    if (this.activeRequest) this.activeRequest.abort()
  }

  scheduleCheck() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.check(), 400)
  }

  markStale() {
    clearTimeout(this.debounceTimer)
    this.setIdle()
  }

  async check() {
    const firstName = this.firstNameTarget.value.trim()
    const lastName = this.lastNameTarget.value.trim()

    if (!firstName || !lastName) {
      this.setIdle()
      return 
    }

    if (this.activeRequest) this.activeRequest.abort()
    const controller = new AbortController()
    this.activeRequest = controller

    const params = new URLSearchParams({ first_name: firstName, last_name: lastName })
    if (this.hasBirthDateTarget && this.birthDateTarget.value ) {
      params.set("birth_date", this.birthDateTarget.value)
    }
    if (this.memberIdValue) {
      params.set("member_id", this.memberIdValue)
    }

    let matches = []
    try {
      const response = await fetch(`${this.checkUrlValue}?${params.toString()}`, {
        headers: { "Accept": "application/json" },
        signal: controller.signal
      })
      if (!response.ok) return
      matches = await response.json()
    } catch (error) {
      if (error.name === "AbortError") return
      console.error("Duplicate check failed", error)
      return
    } finally {
      if (this.activeRequest === controller) this.activeRequest = null
    }

    matches.length > 0 ? this.setDuplicate(matches) : this.setClean()
  }

  setIdle() {
    this.warningTarget.classList.add("hidden")
    this.warningTarget.textContent = ""
  }

  setClean() {
    this.warningTarget.classList.remove("hidden", "text-red-500")
    this.warningTarget.classList.add("text-emerald-500")
    this.warningTarget.textContent = "No similar member found!"
  }

  setDuplicate(matches) {
    this.warningTarget.classList.remove("hidden", "text-emerald-500")
    this.warningTarget.classList.add("text-red-500")
    this.warningTarget.innerHTML = ""

    const sameDistrictMatch = matches.find((match) => match.same_district)
  
    if (sameDistrictMatch) {
      this.warningTarget.appendChild(document.createTextNode("A member with this name already exists in your district: "))

      const link = document.createElement("a")
      link.href = sameDistrictMatch.url
      link.target = "_blank"
      link.rel = "noopener"
      link.className = "underline text-red-500 hover:text-red-900"
      link.textContent = `${sameDistrictMatch.name} (${sameDistrictMatch.sector})`
      this.warningTarget.appendChild(link)
    } else {
      const names = matches.map((match) => `${match.name} (${match.sector})`).join(", ")
      this.warningTarget.textContent = `Similar member(s) already exist: ${names}`
    }
  }
}


